<template lang="html">
  <div class="clientes">
    <section class="middle-intro row-start">
      <div class="container">
        <h1 class="title -intro">{{ $t("clientes.title") }}</h1>
        <img
          src="/static/img/gifs/clientes.gif"
          class="imagen-animacion"
          alt="clientes"
        />
      </div>
    </section>

    <section class="texto-intro container">
      <h2 class="title">{{ $t("clientes.subtitle") }}</h2>
    </section>

    <div class="scroll-mvl container" v-if="lang == 'es'">
      <div class="productos-list row-center ais">
        <article
          :class="['producto', key]"
          v-for="(grupoCliente, key) in $t('clientes.grupos_clientes')"
          :key="key"
          :active="active == key"
        >
          <button class="enlace-cover" @click="setActive(key)"></button>
          <h4 v-html="grupoCliente.title"></h4>
        </article>
      </div>
    </div>
    <div class="content-client container">
      <div
        v-for="(grupoCliente, key) in $t('clientes.grupos_clientes')"
        class="producto-desc row-between container"
        :active="active == key"
        v-if="lang == 'es'"
      >
        <template v-for="(cliente, keyClient) in grupoCliente.items">
          <a :href="cliente" target="_blank" rel="noopener noreferrer">
            <img
              :src="'/static/img/clientes/' + key + '/' + keyClient + '.svg'"
              :alt="keyClient"
            />
          </a>
        </template>
      </div>
      <div
        class="producto-desc row-between container"
        :active="true"
        v-if="lang == 'it'"
      >
        <a :href="cliente" target="_blank" v-for="(cliente, key) in clientesIt">
          <img :src="`/static/img/clientes/${key}.svg`" :alt="key" />
        </a>
      </div>
    </div>

    <!-- <hablan-de-nosotros
      v-if="lang != 'it'"
      :comentarios="$t('clientes.comentarios')"
    ></hablan-de-nosotros> -->

    <!-- <casos-exito :data="$t('clientes.caso_exito')"></casos-exito> -->
  </div>
</template>

<script lang="js">

// import hablanDeNosotros from '@/components/view-parts/clientes/hablan-de-nosotros';
import casosExito from '@/components/parts/casos-exito'
import { mapGetters, mapActions } from 'vuex'
export default {
  name: 'clientes',
  props: [],
  mounted() {

  },
  data() {
    return {
      active: 'corporates',
      clientesIt: {
        "adecco": "https://adecco.es/",
        "saint-global": "https://www.saint-gobain.it/",
      }
    }
  },
  methods: {
      setActive: function (value) {
        this.active = value;
        // $('body,html').animate({ scrollTop: $(".intro-software-gestion").offset().top - 220 }, 800);
      },
  },
  components: {
    // 'hablan-de-nosotros': hablanDeNosotros,
    'casos-exito': casosExito
  },
  computed: {
    ...mapGetters({
      lang: 'getLanguage'
    })
  }
}
</script>

<style scoped>
.texto-intro {
  width: 100%;
  text-align: left;
  color: #41566d;
  margin-bottom: 50px;
}

.texto-intro * {
  max-width: 50%;
}

.texto-intro .title {
  margin-bottom: 10px;
}

.clientes-list {
  max-width: 1100px;
}

.cliente {
  width: 25%;
  height: 200px;
  padding: 40px;
  position: relative;
  cursor: pointer;
}

.cliente img {
  max-width: 100%;
  object-fit: contain;
  width: 100%;
  height: 100px;
}
.producto {
  width: 25%;
  text-align: center;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  align-items: center;
  padding-bottom: 20px;
  position: relative;
  overflow: hidden;
  cursor: pointer;
}

.producto::after {
  width: 100%;
  height: 2px;
  content: "";
  display: inline-block;
  position: absolute;
  left: 0;
  bottom: 2px;
  background: #cecece;
}

.producto::before {
  width: 80%;
  height: 5px;
  content: "";
  display: inline-block;
  position: absolute;
  left: 10%;
  bottom: 1px;
  background: red;
  z-index: 2;
  transform: translateY(10px);
  transition: 0.4s;
  animation-timing-function: ease-in-out;
}
.producto h4 {
  max-width: 200px;
  width: 100%;
  color: #717171;
  font-size: 20px;
  font-weight: 800;
  text-align: center;
  font-family: "Ubuntu Mono";
  transition: 0.5s;
}
.producto.corporates::before {
  background: #41566d;
}
.producto.sectorPublico::before {
  background: #df1517;
}

.producto.consultorasGestoras::before {
  background: #51ac34;
}

.producto.centrosFormacion::before {
  background: #3374b0;
}
.producto.corporates:hover h4,
.producto.corporates[active="true"] h4 {
  color: #41566d;
}

.producto.sectorPublico:hover h4,
.producto.sectorPublico[active="true"] h4 {
  color: #df1517;
}

.producto.consultorasGestoras:hover h4,
.producto.consultorasGestoras[active="true"] h4 {
  color: #51ac34;
}

.producto.centrosFormacion:hover h4,
.producto.centrosFormacion[active="true"] h4 {
  color: #3374b0;
}
.producto:hover::before,
.producto[active="true"]::before {
  transform: translateX(0);
}
.scroll-mvl {
  width: 100vw;
  overflow-x: scroll;
}
.content-client {
  position: relative;
  overflow: hidden;
  padding: 0;
}

.content-client .producto-desc {
  position: absolute;
  left: 0;
  top: 0;
  z-index: 2;
  transform: translateY(-101%);
  background: white;
  transition: 0.5s;
  width: 100%;
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 20px;
  padding-top: 40px;
  padding-bottom: 60px;
}
.content-client .producto-desc img {
  width: 100%;
  max-width: 75%;
  object-fit: contain;
  object-position: center center;
}
.content-client .producto-desc:first-of-type {
  position: relative;
  left: auto;
  top: auto;
}

.content-client .producto-desc[active="true"] {
  transform: translateY(0%);
}

@media screen and (max-width: 1000px) {
  .texto-intro * {
    max-width: 100%;
  }

  .cliente {
    padding: 20px;
    height: 150px;
  }

  .clientes-list {
    padding-bottom: 50px;
  }
}

@media screen and (max-width: 900px) {
  .producto h4 {
    font-size: 18px;
  }
  .content-client .producto-desc {
    grid-template-columns: repeat(3, 1fr);
  }
}
@media screen and (max-width: 790px) {
  .scroll-mvl .productos-list {
    width: inherit;
    min-width: 732px;
  }
}
@media screen and (max-width: 600px) {
  .texto-intro {
    margin-bottom: 20px;
  }

  .cliente {
    width: 33.333333%;
    padding: 10px;
    height: 100px;
  }
  .producto h4 {
    font-size: 15px;
  }
  .scroll-mvl .productos-list {
    width: inherit;
    min-width: 550px;
  }
  .content-client .producto-desc {
    grid-template-columns: repeat(2, 1fr);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/views/clientes.vue